"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchRipple = void 0;
/** @jsx jsx */
const react_1 = require("react");
const core_1 = require("@emotion/core");
const styled_1 = __importDefault(require("@emotion/styled"));
const rippleAnimation = core_1.keyframes `
  0% {
    opacity: 0.1;
    transform: scale(0);
  }
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  0% {
    opacity: 0.75;
  }
  100% {
    opacity: 0;
  }
`;
const StyledTouchRipple = styled_1.default.div `
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  & span {
    animation: ${rippleAnimation} 550ms cubic-bezier(0.4, 0, 0.2, 1);
    background-color: #ffffff;
    border-radius: 50%;
    opacity: 0.3;
    position: absolute;
    transform: scale(0);
  }
`;
const TouchRipple = () => {
    const initializeState = () => ({
        spanStyles: {},
        count: 0,
    });
    const [state, setState] = react_1.useState(initializeState());
    const bounceRef = react_1.useRef(null);
    const bounce = bounceRef.current;
    const getRippleSpanStyles = (x, y, size) => `
    height: ${size}px;
    left: ${x}px;
    top: ${y}px;
    width: ${size}px;
  `;
    const showRipple = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { offsetHeight, offsetWidth } = currentTarget;
        const { left, top } = currentTarget.getBoundingClientRect();
        const size = Math.max(offsetHeight, offsetWidth);
        const centralize = size / 2;
        const axisX = (clientX || 0) - (left || 0) - (centralize || 0);
        const axisY = (clientY || 0) - (top || 0) - (centralize || 0);
        const spanStyles = getRippleSpanStyles(axisX, axisY, size);
        const count = state.count + 1;
        setState({
            count,
            spanStyles: { ...state.spanStyles, [count]: spanStyles },
        });
    };
    const renderRippleSpan = () => {
        const { spanStyles } = state;
        const spanArray = Object.keys(spanStyles);
        if (spanArray.length) {
            return spanArray.map((key, index) => {
                return (core_1.jsx("span", { css: core_1.css `
              ${spanStyles[key]}
            `, key: `spanCount_` + index }));
            });
        }
        else {
            return null;
        }
    };
    const cleanUpRippleSpans = () => {
        const initialState = initializeState();
        setState(initialState);
    };
    const callCleanUp = (cleanup, delay) => {
        return () => {
            if (bounce) {
                clearTimeout(bounce);
            }
            bounceRef.current = setTimeout(() => {
                cleanup();
            }, delay);
        };
    };
    return (core_1.jsx(StyledTouchRipple, { onMouseDown: showRipple, onMouseUp: callCleanUp(cleanUpRippleSpans, 2000) }, renderRippleSpan()));
};
exports.TouchRipple = TouchRipple;
